import headerConst from '../constants/headerConst';

export const navStatus = ({isActive, isPending}) =>
  isActive ? headerConst.navStatus.active : isPending ? headerConst.navStatus.pending : '';
